if (!customElements.get('related-products-recommendations')) {
    class RelatedProductsRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
  
        const observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return;
  
            observer.unobserve(this);
  
            fetch(url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
  
                const recommendations = html.querySelector('related-products-recommendations');
  
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.innerHTML = recommendations.innerHTML;
                  this.classList.add('product-recommendations--loaded');
  
                  setTimeout(() => {
                    const slider = this.querySelector('.related-products-slider');
  
                    if (!slider || slider.classList.contains('swiper-initialized')) return;
  
                    new Swiper(slider, {
                      slidesPerView: parseInt(slider.dataset.desktop) || 4,
                      spaceBetween: parseInt(slider.dataset.space) || 20,
  
                      navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                      },
  
                      breakpoints: {
                        0: {
                          slidesPerView: parseFloat(slider.dataset.mobile) || 2,
                        },
                        500: {
                          slidesPerView: 2,
                        },
                        767: {
                          slidesPerView: parseInt(slider.dataset.tablet) || 3,
                        },
                        1024: {
                          slidesPerView: parseInt(slider.dataset.desktop) || 4,
                        },
                      },
                    });
                  }, 200);
                }
              })
              .catch((e) => console.error(e));
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
  
        observer.observe(this);
      }
    }
  
    customElements.define('related-products-recommendations', RelatedProductsRecommendations);
  }

  